import React from 'react'
import ErrorBoundary from './ErrorBoundary'

export interface ExternalComponentProps {
	compProps?: any
}

export const prepareTrustedComponent = async (Comp: React.ComponentType, onError: (error: Error) => void) => {
	// Loading ErrorBoundary dynamically as it requires react to be loaded first
	await window.externalsRegistry.react.loaded

	return ({ compProps }: ExternalComponentProps) => {
		return (
			<ErrorBoundary onError={onError}>
				<Comp {...compProps} />
			</ErrorBoundary>
		)
	}
}
